var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-content",style:({height: _vm.slideHeight})},[_c('transition',{attrs:{"name":_vm.aniName}},[_c(_vm.view,{tag:"component",on:{"slideTo":_vm.slideToFn,"slideNext":_vm.slideNextFn,"slidePrev":_vm.slidePrevFn}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }